import { getOfferType, isSuburban } from './offer_type';
import { IState } from '../store';

export function isCountrysideCardIntegrated(state: IState) {
  const { kp } = state.offerData;
  const offerType = getOfferType(state.offerData.offer);
  const hasKpInfo = !!kp && !!kp.name && !!kp.url && !!kp.villageClass && !!kp.imageUrl && !!kp.counterSet;

  return Boolean(isSuburban(offerType) && hasKpInfo);
}
